export const minecraft1219 = {
  version: '1.21.9',
  title: 'The Copper Age',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/Minecraft_Fall_Drop_Campaign_Key_Art_DotNet_Blog_Editorial_1280x768.jpg',
  releases: [
    {
      id: "190hY9Zwq",
      version: "beta-0.5-1.0.4",
      date: "Jan 10, 2026",
      changelog: "Quinta versión beta para Minecraft 1.21.9 Copper Age con optimizaciones finales y preparación para versión estable",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.5-1.0.4-1.21.9",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "180hY8Zwp",
      version: "beta-0.4-1.0.4",
      date: "Jan 5, 2026",
      changelog: "Cuarta versión beta para Minecraft 1.21.9 Copper Age con optimizaciones finales y preparación para versión estable",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.4-1.0.4-1.21.9",
      isBeta: true
    },
    {
      id: "170hY7Zwo",
      version: "beta-0.3-1.0.4",
      date: "Dec 25, 2025",
      changelog: "Tercera versión beta para Minecraft 1.21.9 Copper Age con aún más mods agregados y optimizaciones avanzadas",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.3-1.0.4-1.21.9",
      isBeta: true
    },
    {
      id: "160hY6Zwn",
      version: "beta-0.2-1.0.4",
      date: "Dec 20, 2025",
      changelog: "Segunda versión beta para Minecraft 1.21.9 Copper Age con más mods agregados y mejoras de rendimiento",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.2-1.0.4-1.21.9",
      isBeta: true
    },
    {
      id: "150hY5Zwm",
      version: "beta-0.1-1.0.4",
      date: "Dec 15, 2025",
      changelog: "Primera versión beta para Minecraft 1.21.9 Copper Age con mods básicos optimizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.1-1.0.4-1.21.9",
      isBeta: true
    }
  ]
};